import React, { useState } from "react";
import styles from "./Coupons.module.scss";
import DynamicSquaredFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar";
import PlatformGeneratedCoupons from "../../../../components/AdminPortalComponents/MarketingPromotions/Coupons/PlatformGeneratedCoupons/PlatformGeneratedCoupons";
import SellerGeneratedCoupons from "../../../../components/AdminPortalComponents/MarketingPromotions/Coupons/SellerGeneratedCoupons/SellerGeneratedCoupons";

const tabsData = [
    { key: "1", label: "Platform-Generated Coupons" },
    { key: "2", label: "Seller-Generated Coupons" },
];

const Coupons = () => {
    const [activeTab, setActiveTab] = useState(tabsData[0]?.key || "");

    return (
        <div className={styles.mainContainer}>
            <div className={styles.squareFilterBarWrapper}>
                <DynamicSquaredFilterBar
                    tabs={tabsData}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    barType="yellowWhite"
                />
            </div>

            {activeTab === "1" && <PlatformGeneratedCoupons />}
            {activeTab === "2" && <SellerGeneratedCoupons />}
        </div>
    );
};

export default Coupons;